import { render, staticRenderFns } from "./RecommendSet.vue?vue&type=template&id=5fa0dc02&scoped=true&"
import script from "./RecommendSet.vue?vue&type=script&lang=js&"
export * from "./RecommendSet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa0dc02",
  null
  
)

export default component.exports